import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="turbo-helper"
export default class extends Controller {
  clearCache() {
    // Turbo Cache leeren (wichtig für z.B. die Navigation)
    Turbo.cache.clear()

    // Alle data Attribute `data-turbo-permanent` entfernen, damit diese beim nächsten Laden neu initialisiert werden
    document.querySelectorAll("[data-turbo-permanent]").forEach((element) => {
      element.removeAttribute("data-turbo-permanent")
    })
  }

  // Mittels Turbo Morph die Seite neu laden
  refresh() {
    Turbo.session.refresh(location.href)
  }

  // Mittels Turbo Visit die Seite neu laden
  reload() {
    Turbo.visit(location.href, { action: "replace" })
  }

  fullPageReload() {
    window.location.reload()
  }

  preventMorph(event) {
    event.preventDefault()
  }
}
